// -*- js-indent-level: 4; -*-

const $ = jQuery.noConflict();
var tocBreakpoint = 1080;

jQuery(document).ready(function () {
  $("#navigation").each(function () {
    let $nav = $(this);

    const $sectionsWithChildren = $nav.find("ul > li.page_item_has_children");
    const toggleSection = function (index, event) {
      if (event) {
        event.preventDefault();
      }
      const $section = $sectionsWithChildren.eq(index);
      const $toggle = $section.find("> a.section-toggle");
      const $children = $section.find("> ul.children");
      $children.toggleClass("is-collapsed");
      if ($children.hasClass("is-collapsed")) {
        $toggle.addClass("icon-arrow-left").removeClass("icon-arrow-down");
      } else {
        $toggle.addClass("icon-arrow-down").removeClass("icon-arrow-left");
      }
    };

    let currentIndex = 0;

    $sectionsWithChildren.each((i, e) => {
      const $section = $(e);
      const $header = $section.find("> a");
      const $toggle = $("<a></a>")
        .addClass("section-toggle")
        .attr("href", "#")
        .on("click", (e) => toggleSection(i, e))
        .insertBefore($header);
      if ($section.hasClass("current_page_item")) {
        currentIndex = i;
      }
      if ($section.hasClass("current_page_ancestor")) {
        currentIndex = i;
      }
      toggleSection(i);
    });
    // Open the first or the active section
    toggleSection(currentIndex);
  });

  $("#ez-toc-container:first").each(function () {
    let $toc = $(this);
    const articleTop = $("main").offset().top;
    const $teaserImage = $("main div.teaser-image:first");
    let teaserImageBottom = 0;
    if ($teaserImage.length > 0) {
      teaserImageBottom = $teaserImage.offset().top + $teaserImage.height();
    }
    const $moreArticles = $("main .moreArticle");
    let moreArticlesTop = 900000;
    if ($moreArticles.length > 0) {
      moreArticlesTop = $moreArticles.offset().top - $toc.height() - 30;
    }

    let update = () => {
      let scrollTop = $(document).scrollTop();
      if (scrollTop > teaserImageBottom && scrollTop < moreArticlesTop) {
        $toc.addClass("visible");
      } else {
        $toc.removeClass("visible");
      }
    };

    $(window).on("scroll", update).on("resize", update);
    update();

    $("<a/>")
      .text("nach oben")
      .addClass("jump-up")
      .attr("href", "#")
      .on("click", function (e) {
        e.preventDefault();
        $("html")[0].scrollIntoView();
      })
      .appendTo($toc);
  });

  // Collapse table on contents on mobile devices
  $("body").on(
    "click",
    ".evergreen--single-mobile-wrapper #navigation h2, .evergreen-mobile-wrapper #navigation h2",
    function () {
      if ($(window).width() < tocBreakpoint) {
        $(this).closest("#navigation").find("ul").slideToggle();
      }
    },
  );
});
